import { Link } from "react-router-dom";
import PageMeta from "@/components/base/PageMeta";

export default function NotFound() {
  return (
    <>
      <PageMeta
        title="页面不存在 - 年轻的母亲1官网"
        description="你访问的页面不存在或已失效，请返回首页继续浏览年轻的母亲1的剧集、演员与剧情解析。"
        keywords="年轻的母亲1,页面不存在"
      />
      <div className="mx-auto flex min-h-[60vh] max-w-site flex-col items-center justify-center px-4 py-20 text-center md:px-6">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-600">
          <i className="ri-movie-2-line" />
        </span>
        <h1 className="mt-6 text-3xl font-bold text-foreground-950 md:text-4xl">不存在此页面</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在或链接已失效。可以返回首页，或直接前往剧集列表继续浏览《年轻的母亲1》的内容。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category/episodes"
            className="whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览全部剧集
          </Link>
        </div>
      </div>
    </>
  );
}